module.exports = __webpack_public_path__ + "static/Solution-44dc6995684aa5075d10512afabea81d.png";